import { useEffect, useState } from "react";
import "./SiteBanner.scss";
import { CloseOutlined } from "@ant-design/icons";
import { isDSAPath, isLandingPath, setSiteBannerCookie } from "../util/utils";
import { useLocation } from "react-router-dom";
import TextBlockApi from "../api/TextBlockApi";

// Set to true to show banner
// const bannerOn = false;

// Mode can be "top", "bottom", or "banner"
const bannerMode = "top";

enum VisibleMode {
  Visible,
  Hidden,
}

export interface Props {
  setIsSiteBanner: any;
}

export function SiteBanner({ setIsSiteBanner }: Props) {
  const loc = useLocation();
  const [showBanner, setShowBanner] = useState(false);
  const [mode] = useState(VisibleMode.Visible);
  const [content, setContent] = useState("");

  useEffect(() => {
    // const { pathname } = loc;
    // if (isLandingPath(pathname)) {
    //   setMode(VisibleMode.Hidden);
    // } else {
    //   setMode(VisibleMode.Visible);
    // }

    const textBlockName = isDSAPath(loc.pathname) ? "Display Manager Notice" : "Dashboard Notice";
    TextBlockApi.getByName(textBlockName).then((resp) => {
      if (resp.data && resp.data.details) {
        setShowBanner(true);
        setIsSiteBanner(true);
        // setShowBanner(getCookie("showSiteBanner") !== "false")
        setContent(resp.data.details);
      } else {
        setShowBanner(false);
        setIsSiteBanner(false);
      }
    })
  }, [loc, setIsSiteBanner]);

  // useEffect(() => {
  //   const textBlockName = isDSAPath(loc.pathname) ? "Display Manager Notice" : "Dashboard Notice";
  //   TextBlockApi.getByName(textBlockName).then((resp) => {
  //     if (resp.data && resp.data.details) {
  //       // setShowBanner(getCookie("showSiteBanner") !== "false")
  //       setContent(resp.data.details);
  //     }
  //   })
  // }, []);

  function onClose(ev: any) {
    ev.stopPropagation();
    setShowBanner(false);
    setSiteBannerCookie(false);
    console.log(setIsSiteBanner)
    setIsSiteBanner(false);
  }

  return (
    mode === VisibleMode.Hidden ? null : <>
      {showBanner && <div className={`header-promo-banner ${bannerMode}`}>
        <div className="banner-content" dangerouslySetInnerHTML={{ __html: content }}></div>
        <div className="close-btn" onClick={(ev) => onClose(ev)} style={{ display: isLandingPath(loc.pathname) ? "none" : "block" }}><CloseOutlined /></div>
      </div>}
    </>);
}
